import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaCalculoComponent {
  constructor ($state, NominasNomina) {
    this.$state = $state
    this.NominasNomina = NominasNomina
    this.idEmpresa = null
    this.idNomina = null
    this.nominasNomina = null
  }

  $onInit () {
    this.$promise = this.NominasNomina.get(this.idEmpresa, this.idNomina)
      .then((data) => {
        this.acumulado = data.status_acumulado
        this.calculado = data.status_calculado
        this.calculoFecha = data.Calculo_Fecha
      })
  }

  actualizar (data) {
    this.calculado = data.status_calculado
    this.calculoFecha = data.Calculo_Fecha

    this.nominasNomina.data.status_calculado = this.calculado

    this.$state.go('nominas.detalladoNomina.colaboradores')
  }
}

module.component('nominasNominaCalculo', {
  controller: NominasNominaCalculoComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
  },
  require: {
    nominasNomina: '^nomina',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/calculo/component.js